/* Ella Custom JS - Insigneart TR (KNV/Materyal sistemi, 2026-05) */

(function () {
  "use strict";

  var MAT_OPT = '.var-group[data-option-index="0"]';

  /* ---------- Sabit veriler ---------- */
  var PROP_BY_MATERIAL = {
    "Alüminyum Kompozit": [
      ["Materyal", "Alüminyum Kompozit Panel (4mm)"],
      ["Teknoloji", "Tescilli 3D Haptik (Kabartmalı) UV Baskı"],
      ["Doku", "Yükseltilmiş yüzey — hissedilebilir 3D"],
      ["Bitiş", "Mat zemin + yüksek parlak lak aksanları"],
      ["Asma Sistemi", "Hazır asılır gizli sistem (kuruluma hazır)"]
    ],
    "Kanvas (Çerçevesiz)": [
      ["Materyal", "340gsm Premium Kanvas (Rulo, Gerilmemiş)"],
      ["Teknoloji", "Tescilli 3D Haptik (Kabartmalı) UV Baskı"],
      ["Doku", "Yükseltilmiş yüzey — hissedilebilir 3D"],
      ["Bitiş", "Yarı mat + yüksek parlak vernik vurguları"],
      ["Gönderim", "Rulo halinde gönderilir (gerilmemiş, montajsız)"]
    ]
  };

  function canvasDescriptionHTML(title) {
    var t = title || "Bu eser";
    return '' +
      '<h2>' + t + ' — Dokunsal Derinliğin Başyapıtı</h2>' +
      '<p>Düz baskıların ötesine geçin. ' + t + ', ışık altında canlanan kabartmalı 3D yüzeyiyle görülmek ve hissedilmek için tasarlandı.</p>' +
      '<h3>Dokunsal Sanat — Hissedebileceğiniz 3D Doku</h3>' +
      '<p>Biz sadece baskı yapmıyoruz. Çok katmanlı, yüksek çözünürlüklü kabartma ile gerçek derinlik inşa ediyoruz.</p>' +
      '<ul>' +
      '<li><strong>Kabartmalı yüzey:</strong> fırça darbesi benzeri detayları ortaya çıkaran dokunulabilir doku.</li>' +
      '<li><strong>Işığa duyarlı derinlik:</strong> bakış açınız değiştikçe mikro vurgular kayar.</li>' +
      '</ul>' +
      '<h3>Premium Materyal — 340gsm Rulo Kanvas</h3>' +
      '<p>Modern sunum ve galeri kalitesinde bir duruş için özel olarak seçildi.</p>' +
      '<ul>' +
      '<li><strong>Çerçevesiz mimari görünüm:</strong> temiz kenarlar, çağdaş bir bitiş.</li>' +
      '<li><strong>Esnek ve hafif:</strong> rulo halinde güvenle gönderilir; dilediğiniz çerçeveyle tamamlayın.</li>' +
      '</ul>' +
      '<h3>Kromatik Parlaklık</h3>' +
      '<p>Müze kalitesinde UV baskı; derin siyahlar ve elektrik gibi canlı renkler sunar.</p>' +
      '<ul>' +
      '<li><strong>Dosyaya sadakat:</strong> onayladığınız görsel size ulaşır — gerçekte daha da zengin.</li>' +
      '<li><strong>Arşiv ömrü:</strong> solmaya dayanıklı formülasyon, yıllarca dayanır.</li>' +
      '</ul>' +
      '<h3>Bilinçli Lüks</h3>' +
      '<p>Lüks sorumlu olmalı. Greenguard Gold sertifikalı mürekkepler kullanıyoruz.</p>' +
      '<ul>' +
      '<li><strong>İç mekanlar için güvenli:</strong> oturma odası, yatak odası ve çocuk odası için uygundur.</li>' +
      '<li><strong>Premium, sorumlu üretim:</strong> hem kaliteye hem çevreye özen.</li>' +
      '</ul>';
  }

  function aluminumDescriptionHTML(title) {
    var t = title || "Bu eser";
    return '' +
      '<h2>' + t + ' — Dokunsal Derinliğin Başyapıtı</h2>' +
      '<p>Düz baskıların ötesine geçin. ' + t + ', ışık altında canlanan kabartmalı 3D yüzeyiyle görülmek ve hissedilmek için tasarlandı.</p>' +
      '<h3>Dokunsal Sanat — Hissedebileceğiniz 3D Doku</h3>' +
      '<p>Biz sadece baskı yapmıyoruz. Çok katmanlı, yüksek çözünürlüklü kabartma ile gerçek derinlik inşa ediyoruz.</p>' +
      '<ul>' +
      '<li><strong>Kabartmalı yüzey:</strong> fırça darbesi benzeri detayları ortaya çıkaran dokunulabilir doku.</li>' +
      '<li><strong>Işığa duyarlı derinlik:</strong> bakış açınız değiştikçe mikro vurgular kayar.</li>' +
      '</ul>' +
      '<h3>Premium Materyal — 4mm Alüminyum Kompozit Panel</h3>' +
      '<p>Sağlamlık, modern sunum ve galeri kalitesinde bir duruş için özel olarak seçildi.</p>' +
      '<ul>' +
      '<li><strong>Çerçevesiz mimari görünüm:</strong> temiz kenarlar, çağdaş bir bitiş.</li>' +
      '<li><strong>Sağlam ama hafif:</strong> darbeye dayanıklı; arkasında hazır asılır gizli sistem ile kuruluma hazır.</li>' +
      '</ul>' +
      '<h3>Kromatik Parlaklık</h3>' +
      '<p>Müze kalitesinde UV baskı; derin siyahlar ve elektrik gibi canlı renkler sunar.</p>' +
      '<ul>' +
      '<li><strong>Dosyaya sadakat:</strong> onayladığınız görsel size ulaşır — gerçekte daha da zengin.</li>' +
      '<li><strong>Arşiv ömrü:</strong> solmaya dayanıklı formülasyon, yıllarca dayanır.</li>' +
      '</ul>' +
      '<h3>Bilinçli Lüks</h3>' +
      '<p>Lüks sorumlu olmalı. Greenguard Gold sertifikalı mürekkepler kullanıyoruz.</p>' +
      '<ul>' +
      '<li><strong>İç mekanlar için güvenli:</strong> oturma odası, yatak odası ve çocuk odası için uygundur.</li>' +
      '<li><strong>Premium, sorumlu üretim:</strong> hem kaliteye hem çevreye özen.</li>' +
      '</ul>';
  }

  /* ---------- Perks (ikon satiri) override (Kanvas modunda 2 metin degisir) ---------- */
  var PERKS_OVERRIDES_KNV = [
    { match: /Alüminyum\s*Kompozit/i, text: "Premium 340gsm Kanvas" },
    { match: /Asma\s*Aparat/i, text: "Rulo Halinde Teslim" }
  ];
  var origPerks = new Map();
  function applyPerksOverrides() {
    var isKnv = (selectedMaterial() === "Kanvas (Çerçevesiz)");
    document.querySelectorAll(".icon-box span").forEach(function (el) {
      // Bu el daha once override edildi mi? Orijinali (Aluminyum metni) saklanmis.
      if (origPerks.has(el)) {
        var orig = origPerks.get(el);
        if (isKnv) {
          // Orijinal metne gore override bul
          for (var i = 0; i < PERKS_OVERRIDES_KNV.length; i++) {
            if (PERKS_OVERRIDES_KNV[i].match.test(orig)) {
              el.textContent = PERKS_OVERRIDES_KNV[i].text;
              return;
            }
          }
        } else {
          el.textContent = orig;
        }
        return;
      }
      // Ilk kez: orijinali sakla, varsa Kanvas modunda override uygula
      var t = el.textContent || "";
      for (var j = 0; j < PERKS_OVERRIDES_KNV.length; j++) {
        if (PERKS_OVERRIDES_KNV[j].match.test(t)) {
          origPerks.set(el, t);
          if (isKnv) el.textContent = PERKS_OVERRIDES_KNV[j].text;
          return;
        }
      }
    });
  }

  /* ---------- SSS override (Kanvas modunda 2 cevap degisir) ---------- */
  var FAQ_OVERRIDES_KNV = [
    {
      match: /malzem|eğil/i,
      answer: "Eser, 340gsm Premium Kanvas (rulo halinde, gerilmemiş) üzerine uygulanır. Yüksek dokulu yüzeyi ve canlı renk performansıyla galeri kalitesinde bir baskıdır; çerçeveletme ya da iç kasaya gerdirme için kenar payı ile teslim edilir."
    },
    {
      match: /montaj/i,
      answer: "Eser, rulo halinde sağlam bir karton tüpte gönderilir. Çerçevesiz teslim edildiği için dilediğiniz çerçeveyle birleştirebilir veya iç kasaya gerdirip duvara monte edebilirsiniz; kenar payı bunun için bırakılmıştır."
    }
  ];
  var origFaqAnswers = new Map();

  function applyFaqOverrides() {
    var isKnv = (selectedMaterial() === "Kanvas (Çerçevesiz)");
    document.querySelectorAll(".faq-item").forEach(function (item) {
      var q = item.querySelector(".faq-q span");
      var a = item.querySelector(".faq-a");
      if (!q || !a) return;
      var qt = q.textContent || "";
      var ov = null;
      for (var i = 0; i < FAQ_OVERRIDES_KNV.length; i++) {
        if (FAQ_OVERRIDES_KNV[i].match.test(qt)) { ov = FAQ_OVERRIDES_KNV[i]; break; }
      }
      if (!ov) return;
      if (!origFaqAnswers.has(a)) origFaqAnswers.set(a, a.innerHTML);
      a.innerHTML = isKnv ? ov.answer : origFaqAnswers.get(a);
    });
  }

  /* ---------- Yardimcilar ---------- */
  var productData = null;
  var origDesc = null;

  function selectedMaterial() {
    var s = document.querySelector(MAT_OPT + ' input:checked');
    return s ? s.value : null;
  }

  function hideLegacyTech(scope) {
    if (!scope) return;
    var nodes = scope.querySelectorAll("h1,h2,h3,h4,p,strong,b");
    nodes.forEach(function (n) {
      if (/Teknik\s*Özellik/i.test(n.textContent || "")) {
        n.classList.add("tech-specs-legacy-hidden");
        var sib = n.nextElementSibling, g = 0;
        while (sib && g < 6) {
          g++;
          if (sib.tagName === "TABLE") { sib.classList.add("tech-specs-legacy-hidden"); break; }
          if (sib.querySelector && sib.querySelector("table")) { sib.classList.add("tech-specs-legacy-hidden"); break; }
          sib = sib.nextElementSibling;
        }
      }
    });
  }

  /* ---------- 1) Boyut filtreleme ---------- */
  function buildSizeMap() {
    var map = {};
    if (!productData) return map;
    productData.variants.forEach(function (v) {
      if (!v.option2) return;
      if (!map[v.option2]) map[v.option2] = {};
      if (v.available) map[v.option2][v.option1] = true;
    });
    return map;
  }

  function filterSizes() {
    var grp = document.querySelector('.var-group[data-option-index="1"]');
    if (!grp || !productData) return;
    var mat = selectedMaterial();
    if (!mat) return;
    var map = buildSizeMap();
    var inputs = grp.querySelectorAll('input[type="radio"]');
    var firstVisible = null;
    inputs.forEach(function (inp) {
      var lbl = grp.querySelector('label[for="' + inp.id + '"]');
      var ok = map[inp.value] && map[inp.value][mat];
      inp.style.display = ok ? "" : "none";
      if (lbl) lbl.style.display = ok ? "" : "none";
      if (!ok && inp.checked) inp.checked = false;
      if (ok && !firstVisible) firstVisible = inp;
    });
    if (!grp.querySelector("input:checked") && firstVisible) {
      firstVisible.checked = true;
      firstVisible.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  /* ---------- 2) Ozellik tablosu ---------- */
  function renderPropTable() {
    var tbl = document.getElementById("variantPropTable");
    if (!tbl) return;
    var mat = selectedMaterial();
    var props = mat ? PROP_BY_MATERIAL[mat] : null;
    if (!props) { tbl.innerHTML = ""; return; }
    var h = '<div class="vpt-title">Ürün Özellikleri</div>';
    props.forEach(function (r) {
      h += '<div class="vpt-row"><span class="vpt-k">' + r[0] + '</span><span class="vpt-v">' + r[1] + "</span></div>";
    });
    tbl.innerHTML = h;
  }

  /* ---------- 3) Aciklama degistirici ---------- */
  function renderDescription() {
    var desc = document.querySelector(".p-desc");
    if (!desc) return;
    if (origDesc === null) origDesc = desc.innerHTML;
    var mat = selectedMaterial();
    if (mat === "Kanvas (Çerçevesiz)") {
      var title = (productData && productData.title) ? productData.title : "";
      desc.innerHTML = canvasDescriptionHTML(title);
    } else {
      // Aluminyum: orijinal Body varsa onu, yoksa generic Aluminyum sablonu
      var hasOrig = origDesc && origDesc.replace(/<[^>]+>/g, "").trim().length > 20;
      if (hasOrig) {
        desc.innerHTML = origDesc;
      } else {
        var title = (productData && productData.title) ? productData.title : "";
        desc.innerHTML = aluminumDescriptionHTML(title);
      }
    }
  }

  /* ---------- 4) Galeri filtreleme (materyale gore) ---------- */
  function filterGallery() {
    var mat = selectedMaterial();
    if (!mat) return;
    var isKnv = (mat === "Kanvas (Çerçevesiz)");
    var items = document.querySelectorAll(".gallery-item, .mobile-slide");
    items.forEach(function (el) {
      var a = el.getAttribute("data-mat") || "";
      var isCanvasImg = a.indexOf("MAT:KNV") !== -1;
      // class + !important: Ella variant JS inline style ezse bile gecerli
      if (isKnv === isCanvasImg) {
        el.classList.remove("mat-hidden");
      } else {
        el.classList.add("mat-hidden");
      }
    });
  }

  function filterGalleryMulti() {
    filterGallery();
    setTimeout(filterGallery, 150);
    setTimeout(filterGallery, 500);
    setTimeout(filterGallery, 1000);
  }

  // Galeri container'i izle: Ella DOM'u yeniden kurarsa tekrar filtrele
  var galleryObserver = null;
  function observeGallery() {
    if (galleryObserver) return;
    var targets = document.querySelectorAll(".desktop-gallery, .mobile-slider-wrapper");
    if (!targets.length) return;
    galleryObserver = new MutationObserver(function () {
      if (galleryObserver._busy) return;
      galleryObserver._busy = true;
      filterGallery();
      setTimeout(function () { galleryObserver._busy = false; }, 50);
    });
    targets.forEach(function (t) {
      galleryObserver.observe(t, { childList: true, subtree: true, attributes: true, attributeFilter: ["style", "class"] });
    });
  }

  function refreshAll() {
    filterSizes();
    renderPropTable();
    renderDescription();
    applyFaqOverrides();
    applyPerksOverrides();
    filterGalleryMulti();
    observeGallery();
  }

  /* ---------- Init ---------- */
  function init() {
    if (!document.querySelector(".var-area")) return;
    var desc = document.querySelector(".p-desc");
    if (desc && origDesc === null) origDesc = desc.innerHTML;

    fetch(window.location.pathname + ".js")
      .then(function (r) { return r.json(); })
      .then(function (p) {
        productData = p;
        refreshAll();
      })
      .catch(function () { refreshAll(); });
  }

  // Material degisimi (event delegation; Halo DOM'u kursa da calisir)
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(MAT_OPT)) {
      renderPropTable();
      renderDescription();
      filterSizes();
      filterGalleryMulti();
      applyFaqOverrides();
      applyPerksOverrides();
    }
  });
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(MAT_OPT)) {
      setTimeout(function () { renderPropTable(); renderDescription(); filterSizes(); filterGalleryMulti(); applyFaqOverrides(); applyPerksOverrides(); }, 40);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
